module.exports = __webpack_public_path__ + "static/img/Gacha06.5b57996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha06.png
// module id = 11kF
// module chunks = 1